import React, { useContext, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import toast from "react-hot-toast";
import blogFetch from "../../axios/config";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import CardMolds from "./CardMolds";
import UpdateMaintenance from "./UpdateMaintenance";
import SimpleModal from "../../components/SimpleModal";
import Context from "../../context/Context";
import Loading from "../../components/Loading";
import language from "../../nls/language.json";
import { InputGroup, Form, Button } from "react-bootstrap";
import './Maintenance.css'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const INITIAL_MODAL = {
  isShow: false,
  title: "",
  body: ""
}
const Maintenance = () => {
  const [data, setData] = useState([])
  const [inputMold, setInputMold] = useState("")
  const [showModal, setShowModal] = useState(INITIAL_MODAL);

  const {
    loadingFullScreen,
    setLoadingFullScreen,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getMolds();
  }, [])

  const getMolds = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_Moldes?moldStatus=MANUTENCAO`);

      // LOG PARA DEBUG (Essencial agora)
      console.log("Dados recebidos da API:", data);

      // Se você quer ver TODAS as pendências, apenas passe o data direto.
      // Se a API retorna PascalCase (Molde_Key), o React deve ler PascalCase.
      setData(data);

    } catch (error) {
      console.error(error);
    }
  };

  const exportToExcel = () => {
    if (!data || data.length === 0) {
      toast.error("Não há dados para exportar");
      return;
    }

    // Transforma os dados em uma planilha
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Cria o workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Manutencoes");

    // Gera o arquivo Excel
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    // Cria um Blob e baixa o arquivo
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `manutencoes_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const handleInputMold = ({ target }) => {
    const { value } = target;
    setInputMold(value);
  }

  const handleKeyDown = (e) => {
    // e.code
    if (e.key === "Enter" || e.key === 'Tab' || e.key === 'NumpadEnter') {
      const barCode = inputMold.split('.');
      if (barCode.length !== 3)
        return toast.error(language[selectedCountry.name].Manutencao.notification.errorBarCode, {
          duration: 4000,
        });

      const [_, moldKey, __] = barCode;
      const param = {
        molde_Key: moldKey,
        molde_Status: "ESTOQUE",
      };

      putMold(param);
    }
  }

  const handleModal = (data, title) => {
    setShowModal({
      isShow: true,
      body: bodyEditPendencias(data),
      title: title
    })
  }

  const handleConfirmed = (data) => {
    const params = {
      molde_Key: data.molde_Key,
      molde_Status: "ESTOQUE",
    }

    putMold(params);
    putPendency({
      molde_Pend_Key: data.molde_Pend_Key,
      molde_Pend_DataPrevisao: data.molde_Pend_DataPrevisao
    });
  }

  const putMold = async (params) => {
    try {
      await blogFetch.put(`/ISAGA_Moldes/MoldesUpdateStatusManutencao`, params);

      setInputMold('');
      toast.success(language[selectedCountry.name].Manutencao.notification.successUpdate, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Manutencao.notification.errorUpdate, {
        duration: 4000,
      });
    }
  }

  const putPendency = async (pendencia) => {
    try {
      setLoadingFullScreen(true);
      await blogFetch.put(`/ISAGA_MoldePendencias`, pendencia);

      getMolds();

      setShowModal(INITIAL_MODAL);
      toast.success(language[selectedCountry.name].Manutencao.notification.successUpdatePendency, {
        duration: 4000,
      });
    } catch (error) {
      console.error(error);
      toast.error(language[selectedCountry.name].Manutencao.notification.apontarBloqueioPendency, {
        duration: 4000,
      });
    }
    finally {
      setLoadingFullScreen(false);
    }
  }

  const bodyEditPendencias = (data) => {
    return (
      <UpdateMaintenance
        pendency={data}
        hangleStatusPendencias={putPendency}
      />
    )
  }

  const [searchPieces, setSearchPices] = useState("");
  const filteredParts = data.filter(
    ({ molde_Codigo }) =>
      molde_Codigo.toString().toLowerCase().includes(searchPieces.toLowerCase())
  );

  return (
    <>
      < Navbar />

      < Sidebar />

      {loadingFullScreen && (
        <Loading />
      )}

      <div
        className={`app_body d-flex flex-wrap mold-container`}
      >
        {!!data && data.length
          ? (
            <div className="m-0 d-flex flex-column">
              <SimpleModal
                isShow={showModal.isShow}
                title={showModal.title}
                body={showModal.body}
                INITIAL_MODAL={INITIAL_MODAL}
                setShowModal={setShowModal}
              />
              <div className="">
                <InputGroup>
                  <Form.Control
                    placeholder="Buscar Molde - Codigo do Molde"
                    value={searchPieces}
                    onChange={({ target }) => setSearchPices(target.value)}
                  />
                  <Button className="status-molde-button-form">
                    Buscar
                  </Button>
                </InputGroup>
              </div>

              <div className="d-flex flex-row flex-wrap w-100 justify-content-start ms-2 p-0 m-2">
                <button
                  onClick={exportToExcel}
                  className="btn btn-success fw-semibold shadow-sm px-1 py-2 rounded-3"
                >
                  <i className="bi bi-file-earmark-excel me-2"></i>
                  Exportar Excel
                </button>

                {filteredParts
                  .map((mold, i) => (
                    <CardMolds
                      key={`mold-maintenance-${i}`}
                      data={mold}
                      handleConfirmed={handleConfirmed}
                      handleUpdate={handleModal} />
                  ))}
              </ div>
            </div>

          )
          : (
            <div>
              {language[selectedCountry.name].Manutencao.semMolde}
            </div>
          )}
      </div>
    </>
  )
}

export default Maintenance;